<template>
  <div class="audio-uploader">
      <h3 v-if="title">{{ title }}</h3>
    <FileUploader 
      v-model="audioUrl"
      file-type="audio"
      :button-text="placeholder || 'Upload Audio'"
      @upload-success="handleUploadSuccess"
      @upload-error="handleUploadError"
      @file-selected="$emit('file-selected', $event)"
    />
  </div>
</template>

<script>
import FileUploader from '@/components/FileUploader.vue';

export default {
  name: "AudioUploader",
  components: {
    FileUploader
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Upload Audio"
    },
    maxFileCount: {
      type: Number,
      default: 1
    },
    modelValue: {
      type: String,
      default: ""
    }
  },
  emits: ['update:modelValue', 'upload-success', 'upload-error', 'audio-removed', 'file-selected'],
  data() {
    return {
      audioUrl: this.modelValue
    };
  },
  watch: {
    modelValue(newValue) {
      this.audioUrl = newValue;
    },
    audioUrl(newValue) {
      this.$emit("update:modelValue", newValue);
    }
  },
  methods: {
    handleUploadSuccess(result) {
      this.$emit("upload-success", result.fileUrl, result.originalName || "audio file");
    },
    handleUploadError(error) {
      this.$emit("upload-error", error);
    }
  }
};
</script>

<style scoped>
.audio-uploader {
  margin-bottom: 1.5rem;
}
</style> 